// 用于登录注册页面输入框获取焦点失去焦点改变样式
var keyA = 'show'
var keyB = 'focus'
function initControl(objects, type) {
  let styleControl = {}
  for(let keys in objects) {
    if (type === 'Boolean') styleControl[keys] = false
    if (type === 'Object') {
      styleControl[keys] = {}
      styleControl[keys][keyA] = false
      styleControl[keys][keyB] = false
    }
  }
  return styleControl
}
import { ValidateRequire } from '@/common/utils/validate.js'
export default (objects) => ({
  inject: ['parentRoot'],
  data() {
    return {
      keyA,
      keyB,
      styleControl: initControl(objects, 'Object'),
    }
  },
  created() {},
  methods: {
    onFocus(v) { // 聚焦变化
      if (this.styleControl[v] !== undefined) {
        this.styleControl[v][keyA] = true
        this.styleControl[v][keyB] = true
      }
    },
    onBlur(v) { // 失去焦点变化
      if(this.ruleForm[v].length > 0) this.$set(this.ruleForm, v, this.ruleForm[v].replace(/(^\s*)|(\s*$)/g, "")) // 去掉前后空格
      if (this.styleControl[v] !== undefined && !ValidateRequire(this.ruleForm[v]) && (this.ruleForm[v].length === 0)) this.styleControl[v][keyA] = false
      this.styleControl[v][keyB] = false
    },
    initFormControl(v) {
      if (this.styleControl[v] !== undefined && ValidateRequire(this.ruleForm[v])) this.styleControl[v][keyA] = true
    }
  }
})



// WEBPACK FOOTER //
// ./src/pages/build800/views/mixins/formStyleChange2.js